import { render, staticRenderFns } from "./scm.vue?vue&type=template&id=22eecbb8"
import script from "./scm.vue?vue&type=script&lang=js"
export * from "./scm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports